import { Flex } from '@mantine/core'
import { useRouter } from 'next/router'
import { useState } from 'react'

import { useQueryGetAllInquiries } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Page } from '@flecto/ui/saas'

import { FiltersInquiries } from '../components/FiltersInquiries/FiltersInquiries'
import { TableInquiries } from '../components/TableInquiries/TableInquiries'

export function PageInquiryList() {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const [filteredInquiries, setFilteredInquiries] = useState<CoreInquiry[]>([])

  const router = useRouter()

  const { data, isLoading } = useQueryGetAllInquiries()

  return (
    <Page>
      <Page.Title>{t('title')}</Page.Title>
      <Page.Content>
        <Flex justify={'flex-end'} mb='md'>
          <FiltersInquiries
            inquiries={data?.inquiry ?? []}
            onFilter={setFilteredInquiries}
          />
        </Flex>
        <TableInquiries
          inquiries={filteredInquiries}
          isLoading={isLoading}
          highlightOnHover
          onRowClick={({ record: row }) =>
            router.push(`/inquiries/${row.internal_id}`)
          }
        />
      </Page.Content>
    </Page>
  )
}
